import React from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import Problem from '../components/Problem';
import RealExamples from '../components/RealExamples';
import Solution from '../components/Solution';
import HowItWorks from '../components/HowItWorks';
import CaseStudy from '../components/CaseStudy';
import Pricing from '../components/Pricing';
import Trust from '../components/Trust';
import FAQ from '../components/FAQ';
import FinalCTA from '../components/FinalCTA';
import Contact from '../components/Contact';
import Footer from '../components/Footer';

const LandingPage = () => {
  return (
    <main className="min-h-screen bg-zinc-50 selection:bg-zinc-950 selection:text-white">
      <Header />
      <Hero />
      <Problem />
      <RealExamples />
      <Solution />
      <HowItWorks />
      <CaseStudy />
      <Pricing />
      <Trust />
      <FAQ />
      <FinalCTA />
      <Contact />
      <Footer />
    </main>
  );
};

export default LandingPage;